<template>
  <div class="time">
    <div class="sensor-top">
      <div class="sensor-top-left">
        <div class="two-font-wrapper" @click="inCrib">
          <div class="icon-font">&#xe606;</div>
          入垛
        </div>
        <div class="two-font-wrapper" @click="deleteCribAll">
          <div class="icon-font">&#xe602;</div>
          解垛
        </div>
        <!--        <div class="four-font-wrapper"><div class="icon-font">&#xe7d1;</div>预警配置</div>-->
      </div>
      <div class="sensor-top-right">
        <div class="input-wrapper">
          <input v-model="nodeId" placeholder="请输入关键字" />
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="detail-item" style="width: 5%">
            <span
              class="select-icon"
              :class="{ 'select-icon-active': all }"
              @click="selectAll"
            ></span>
          </div>
          <div class="detail-item" style="width: 10%">ID</div>
          <div class="detail-item" style="width: 10%">传感器类型</div>
          <div class="detail-item" style="width: 30%">位置</div>
          <div class="detail-item" style="width: 15%">入垛时间</div>
          <div class="detail-item" style="width: 10%">坐标</div>
          <div class="detail-item" style="width: 20%">操作</div>
        </div>
        <div class="detail-content">
          <div
            class="detail-list-wrapper"
            v-if="!loading && tableData.length > 0"
            v-for="(data, index) in tableData"
            :key="index"
          >
            <div class="detail-item" style="width: 5%">
              <span
                class="select-icon"
                :class="{ 'select-icon-active': data.sign === 1 }"
                @click="selectSingle(data.id)"
              ></span>
            </div>
            <div class="detail-item" style="width: 10%">{{ data.nodeId }}</div>
            <div class="detail-item" style="width: 10%">无线温湿度传感器</div>
            <div class="detail-item" style="width: 30%">
              {{ data.stack }}
            </div>
            <div class="detail-item" style="width: 15%">
              {{ renderTime(data.intoStackTime) }}
            </div>
            <div class="detail-item" style="width: 10%">
              X:{{ data.siteX }}&nbsp;Y:{{ data.siteY }}&nbsp;Z:{{ data.siteZ }}
            </div>
            <div class="detail-item" style="width: 20%">
              <div
                class="detail-btn item-look"
                @click="lookSensor(data.nodeId)"
              >
                查看
              </div>
              <div
                  class="detail-btn item-edit"
                  @click="updateSensor(data.nodeId, '03')"
                  style="margin-left: 0.5vw"
                >
                  修改
                </div>
              <div
                class="detail-btn item-audit"
                style="margin: 0 0.5vw"
                @click="exportData(data.nodeId)"
              >
                导出
              </div>
              <div class="detail-btn item-delete" @click="deleteCrib(data.id)">
                解垛
              </div>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length < 1">
            暂无数据
          </div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">
            共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
              rows
            }}条，当前第{{ page }}页
          </div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="Tzpage">跳转至</div>
            <div class="page-btn"><input @blur="Tzpage" v-model="page" /></div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="alert-box" v-if="show">
          <div class="alert-content">
            <div class="alert-content-title">解垛提醒</div>
            <div class="alert-content-msg">是否确认解垛选择数据?</div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelDelete">取消</div>
              <div class="btn-confirm button" @click="confirmDelete">确认</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DropDown from "../../../../components/DropDownSingle.vue";
import { exportJson } from "../../../../vendor/Export2Excel";
import click from "../../../../tools/click";
import localforage from 'localforage'
import {
  queryRtNodeMonitInfo,
  nodesOutStack,
  exportNodeHistoryInfo,
} from "../../../../api/maintain";
import { renderTime } from "../../../../tools/methods";
export default {
  name: "TimeSensor",
  components: { DropDown },
  data() {
    return {
      moduleType: "03",
      nodeType: "06",
      nodeId: "",
      siteId: "",
      siteType: "",
      loading: true,
      page: 1,
      rows: 6,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
      show: false,
      all: false,
      id: "",
      type: 0,
      idList: [],
    };
  },
  created() {
    this.handleSearch(1);
     let _this = this
    localforage.getItem('page_rem_warehouse_wareTumeSensor').then(res => {
      if (res) {
        _this.page=res
        _this.handleSearch(1);
      }
    })
  },
  mounted() {
    let that = this;
    click.$on("click_first", function (siteId, siteType) {
      that.siteId = siteId;
      that.siteType = siteType;
      that.handleSearch(1);
    });
  },
  methods: {
    renderTime: function (time) {
      return renderTime(time);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    exportData: function (nodeId) {
      let body = {
        nodeId: nodeId,
      };
      exportNodeHistoryInfo(body)
        .then((res) => {
          console.log(res);
          res.data.map((item) => {
            item.createdTime = renderTime(item.createdTime);
          });
          require.ensure([], () => {
            let tHeader = [
              "传感器ID",
              "传感器类型",
              "温度(℃)",
              "湿度（%）",
              "采集位置",
              "入垛时间",
              "创建时间",
              "坐标",
            ];
            let filterVal = [
              "nodeId",
              "nodeTypeName",
              "temp",
              "moisture",
              "gatherSite",
              "intoStackTime",
              "createdTime",
              "xyz",
            ];
            const list = res.data;
            const data = this.formatJson(filterVal, list);
            exportJson(tHeader, data, "传感器配置列表");
            this.$message({
              message: "导出成功!",
              type: "success",
              center: "true",
              duration: 1000,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteCrib: function (id) {
      this.show = true;
      this.id = id;
      this.type = 0;
    },
    deleteCribAll: function () {
      if (this.idList.length !== 0) {
        this.show = true;
        this.type = 1;
      } else {
        this.$message({
          message: "请选择要解垛的传感器!",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
      console.log(this.idList);
    },
    cancelDelete: function () {
      this.show = false;
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id);
        let arr = [this.id];
        nodesOutStack(JSON.parse(JSON.stringify(arr)))
          .then((res) => {
            console.log(res);
            this.$message({
              message: "解垛成功!",
              type: "success",
              center: "true",
              duration: "1000",
            });
            this.show = false;
            this.handleSearch();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log(this.idList);
        let arr = this.idList;
        nodesOutStack(JSON.parse(JSON.stringify(arr)))
          .then((res) => {
            console.log(res);
            this.$message({
              message: "解垛成功!",
              type: "success",
              center: "true",
              duration: "1000",
            });
            this.show = false;
            this.handleSearch();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    selectAll: function () {
      this.type = 1;
      this.all = !this.all;
      let idList = [];
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1;
          idList.push(data.id);
        });
        this.idList = idList;
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0;
          this.idList = [];
        });
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1;
          if (data.sign === 1) {
            this.idList.push(data.id);
          } else {
            let idList = [];
            this.idList.map((item) => {
              if (item !== id) {
                idList.push(item);
              }
            });
            this.idList = idList;
          }
          console.log(this.idList);
        }
      });
      this.all = this.idList.length === this.tableData.length;
    },
    lookSensor: function (nodeId) {
      this.$router.push({
        path: "/timeLookSensor",
        query: {
          index: "3",
          nodeId: nodeId,
        },
      });
    },
    updateSensor: function (nodeId,x) {
      this.$router.push({
        path: "/timeUpdateSensor",
        query: {
          index: "3",
          nodeId: nodeId,
          moduleType:x,
        },
      });
    },
    inCrib: function () {
      this.$router.push({
        path: "/timeInCrib",
        query: {
          index: "3",
          moduleType: this.moduleType,
        },
      });
    },
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1;
      }
      this.loading = true;
      let body = {
        moduleType: this.moduleType,
        nodeType: this.nodeType,
        nodeId: this.nodeId,
        page: this.page,
        rows: this.rows,
        siteId: this.siteId,
        siteType: this.siteType,
      };
      queryRtNodeMonitInfo(body)
        .then((res) => {
          console.log(res);
          res.data.rows.map((item) => {
            item.sign = 0;
          });
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
          // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      } else {
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        localforage.setItem('page_rem_warehouse_wareTumeSensor', this.page)
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Time.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/timeMonitoring/WareTimeSensor.vue